export function updateCategories(state, payload) {
  state.all = payload;
}
